

if (!customElements.get('recharge-bundle')) {
  customElements.define(
    'recharge-bundle',
    class RechargeBundle extends HTMLElement {
      constructor() {
        super();
        this.extraSection = this.querySelector('[js-extra-section]');
        this.mainSection = this.querySelector('[js-main-section]');
        this.extraSummary = this.querySelector('[js-extra-summary-items]');
        this.mainSummary = this.querySelector('[js-main-summary-items]');
        this.bottomBarSummary = this.querySelector('[js-bottom-bar-selection]');
        this.summaryTotalPrices = this.querySelectorAll('[js-summary-total-price]');
        this.addBtns = this.querySelectorAll('[js-add]');
        this.editBtns = this.querySelectorAll('[js-edit]');
        this.addBtns.forEach((btn)=> {
          btn.addEventListener("click", (event)=> {
             this.onAddClick(event);
          });
        });
        this.editBtns.forEach((btn)=> {
          btn.addEventListener("click", (event)=> {
             this.onEditClick(event);
          });
        });
        this.optionSelectors = this.querySelectorAll('variant-selects-new select');
        this.optionSelectors.forEach(select => {
           select.addEventListener("change", (event)=> {
              this.updateMainVariantSelect(event);
          });
        });  
        this.addToCartBtns = document.querySelectorAll('[js-add-btn]');
        this.addToCartBtns.forEach((btn)=> {
          btn.addEventListener("click", (event)=> {
             this.onAddToCartClick(event);
          });
        });
      }
      async onAddToCartClick(event) {
          this.addToCartBtns.forEach((btn)=> {
            btn.setAttribute('disabled', true);
            btn.classList.add('loading');
          });
          const bundleSellingPlanDropDown = this.querySelector('[ js-summary-step] [js-selling-plan-dropdown]');
          if(!bundleSellingPlanDropDown) return false;
          const bundleProductID = bundleSellingPlanDropDown.getAttribute('js-product-id');
          const bundleVariantID = bundleSellingPlanDropDown.getAttribute('js-variant-id');
          const bundleProductHandle = bundleSellingPlanDropDown.getAttribute('js-product-handle');
          const sellingPlanValue = bundleSellingPlanDropDown.value;
          const randomString = this.getString(8);

          let items = [];
          let deliveryDate = '';
          this.mainSection.querySelectorAll('[js-product-item].selected').forEach((item)=> {
            const qty = Number(item.querySelector('[js-qty-value]').innerText);
            const collectionID = item.getAttribute('data-collection-id');
            const variantID = item.querySelector('[js-variant-dropdown]').value;
            const selectEl = item.querySelector('[js-frequency-dropdown]');
            const matchingOption = Array.from(selectEl.options).find(option => option.text.trim() === sellingPlanValue);
            deliveryDate = item.querySelector('[js-variant-dropdown]').getAttribute('data-date');
           
           
            const tempItem = {
              id: variantID,
              quantity: qty,
              selling_plan: matchingOption.value,
              properties: {
              "_rc_bundle": `${randomString}_:${bundleProductID}`,
              "_rc_bundle_parent": bundleProductHandle,
              "_rc_bundle_variant": bundleVariantID,
              "_rc_bundle_collection_id": collectionID
              }
            };

            if (variantID == "55136428163448") {
              let bundleFreeProduct = {
                id: "55364634280312",
                quantity: 1,
              };
              items.push(bundleFreeProduct);
            }

            items.push(tempItem);
         });
          this.extraSection.querySelectorAll('[js-product-item].selected').forEach((item)=> {
            const qty = Number(item.querySelector('[js-qty-value]').innerText);
            const collectionID = item.getAttribute('data-collection-id');
            const variantID = item.getAttribute('data-variant-id');
            const selectEl = item.querySelector('[js-frequency-dropdown]');
            const matchingOption = Array.from(selectEl.options).find(option => option.text.trim() === sellingPlanValue);

            const tempItem = {
              id: variantID,
              quantity: qty,
              selling_plan: matchingOption.value,
              properties: {
              "_rc_bundle": `${randomString}_:${bundleProductID}`,
              "_rc_bundle_parent": bundleProductHandle,
              "_rc_bundle_variant": bundleVariantID,
              "_rc_bundle_collection_id": collectionID
              }
            };
            items.push(tempItem);
         });


           
            const cart = await fetch('/cart.js').then(res => res.json());
            const updates = {};
            cart.items.forEach(item => {
              if (item.properties && item.properties._rc_bundle) {
                updates[item.key] = 0;
              }
            });
        
            await fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                updates,
                attributes: {
                  date: deliveryDate
                }
              })
            });

        
            fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({ items })
            })
            .then(response => {
              if (!response.ok) throw new Error("Network response was not ok.");
              return response.json();
            })
            .then(() => {
              this.addToCartBtns.forEach((btn)=> {
                btn.removeAttribute('disabled');
                btn.classList.remove('loading');
              });
              window.location.href = "/cart";
            })
            .catch(error => {
              console.error("Add to cart error:", error);
            });
        
      }
      getString(length) {
            let result = '';
            let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
       }
      getSelectedOptions() {
          return Array.from(this.optionSelectors).map(select => select.value);
      }
      findMatchingVariant(selectedOptions) {
          const variants = JSON.parse(this.querySelector("#ProductJson").textContent);
          return variants.find(variant => {
            return selectedOptions.every((opt, idx) => variant[`option${idx + 1}`] === opt);
          });
      }
      updateMainVariantSelect(event) {
         const selectedOptions = this.getSelectedOptions();
         const matchingVariant = this.findMatchingVariant(selectedOptions);
         const mainVariantSelect = this.querySelector('select.main-select');
          if (matchingVariant) {
            mainVariantSelect.value = matchingVariant.id;
            this.querySelectorAll('[js-main-price]').forEach((item)=> {
              item.innerText =  this.moneyFormat(matchingVariant.price);
            });
            if(this.querySelectorAll('[js-main-section] [js-product-item]').length > 0) {
              this.querySelectorAll('[js-main-section] [js-product-item]').forEach((item)=> {
                item.setAttribute('data-price', matchingVariant.price);
              });
            }
          }
      }
      onAddClick(event) {
        const lineItem = event.target?.closest('[js-product-item]');
        if(!lineItem) return false;
        const qtyValue = Number(lineItem.querySelector('[js-qty]')?.value);
        if(qtyValue == 0) {
          lineItem.classList.remove('active');
          lineItem.classList.remove('selected');
        }
        else {
          lineItem.classList.add('active');
          lineItem.classList.add('selected');
        }
        lineItem.querySelector('[js-qty-value]').innerText = qtyValue;
        console.log('qtyValue', qtyValue);
        this.updateSummary();
      }   
      onEditClick(event) {
        const lineItem = event.target?.closest('[js-product-item]');
        if(!lineItem) return false;
        lineItem.classList.remove('active');
      }   
      updateSummary() {
        let extraItemHTML = '';
        let mainItemHTML = '';
        let totalPrice = 0;
        let totalQty = '';
       
        this.extraSection.querySelectorAll('[js-product-item].selected').forEach((item)=> {
           const qty = Number(item.querySelector('[js-qty-value]').innerText);
           const price = item.getAttribute('data-price');
           const image = item.getAttribute('data-image');
           const title = item.getAttribute('data-title');
          totalPrice = totalPrice + price*qty;
          totalQty++;
          extraItemHTML += `<div class="summary-item">
           <div class="left">
           <div class="image">
           <img src="${image}" />
           </div>
           <div class="text">
             <div class="title">${title}</div>
             <div class="line-price">${this.moneyFormat(price*qty)}</div>
              <div class="line-qty">X${qty}</div>
           </div>
           </div><div class="right">${this.moneyFormat(price)}</div>
           </div>`;
        });
        this.mainSection.querySelectorAll('[js-product-item].selected').forEach((item)=> {
           const qty = Number(item.querySelector('[js-qty-value]').innerText);
           const price = item.getAttribute('data-price');
           const image = item.getAttribute('data-image');
           const title = item.getAttribute('data-title');
          const selectElement = item.querySelector('[js-variant-dropdown]'); 
          const variantTitle = selectElement.options[selectElement.selectedIndex].text;
          totalPrice = totalPrice + price*qty;
          totalQty++;
          mainItemHTML += `<div class="summary-item">
           <div class="left">
            <div class="image">
           <img src="${image}" />
           </div>
           <div class="text">
             <div class="title">${title}</div>
            <div class="variant-title">${variantTitle}</div>
             <div class="line-price">${this.moneyFormat(price*qty)}</div>
              <div class="line-qty">X${qty}</div>
           </div>
           </div><div class="right">${this.moneyFormat(price)}</div>
           </div>`;
          
            const nextBtns = document.querySelectorAll('[js-next-btn]');
            nextBtns.forEach((nextBtn)=> {
              nextBtn.removeAttribute('disabled');
              const buttonText = nextBtn.getAttribute('data-next-btn-text');
              if(buttonText) nextBtn.innerText = buttonText;
            });
          
        });
        this.extraSummary.innerHTML = extraItemHTML;
        this.mainSummary.innerHTML = mainItemHTML;
        this.bottomBarSummary.innerHTML = `${totalQty} selected - ${this.moneyFormat(totalPrice)}`;
        this.summaryTotalPrices.forEach((element)=> {
           element.innerHTML = `${this.moneyFormat(totalPrice)}`;
        });
      }
      moneyFormat(cents) {
        var Shopify = Shopify || {};
        let format = "£{{amount}}";
       
                  if (typeof cents == 'string') { cents = cents.replace('.',''); }
                  var value = '';
                  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
                  var formatString = (format || this.money_format);
                
                  function defaultOption(opt, def) {
                     return (typeof opt == 'undefined' ? def : opt);
                  }
                
                  function formatWithDelimiters(number, precision, thousands, decimal) {
                    precision = defaultOption(precision, 2);
                    thousands = defaultOption(thousands, ',');
                    decimal   = defaultOption(decimal, '.');
                
                    if (isNaN(number) || number == null) { return 0; }
                
                    number = (number/100.0).toFixed(precision);
                
                    var parts   = number.split('.'),
                        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                        cents   = parts[1] ? (decimal + parts[1]) : '';
                
                    return dollars + cents;
                  }
                
                  switch(formatString.match(placeholderRegex)[1]) {
                    case 'amount':
                      value = formatWithDelimiters(cents, 2);
                      break;
                    case 'amount_no_decimals':
                      value = formatWithDelimiters(cents, 0);
                      break;
                    case 'amount_with_comma_separator':
                      value = formatWithDelimiters(cents, 2, '.', ',');
                      break;
                    case 'amount_no_decimals_with_comma_separator':
                      value = formatWithDelimiters(cents, 0, '.', ',');
                      break;
                  }
                  return formatString.replace(placeholderRegex, value).replace('.00', '');
          
    }
    }
    );
}



const nextBtns = document.querySelectorAll('[js-next-btn]');
const activeTab = document.querySelector('.progress-bar li.active');
const upcomingTab = document.querySelector('.progress-bar li.upcoming');
nextBtns.forEach((nextBtn)=> {
  nextBtn?.addEventListener("click", (event)=> {
    window.scrollTo(500, 0);
    const addBtn = document.querySelector('[js-add-btn]');
    const summaryStep = document.querySelector('[js-summary-step]');
    const productsStep = document.querySelector('[js-products-step]');
    const bottomBar = document.querySelector('[js-bottom-bar]');
    
   nextBtns.forEach((nextBtn)=> {
      nextBtn.classList.add('hidden');
     });
    addBtn?.classList.remove('hidden');
    summaryStep?.classList.remove('hidden');
    productsStep?.classList.add('hidden');
    bottomBar?.classList.add('hidden');
    activeTab?.classList.add('completed');
    activeTab?.classList.remove('active');
     upcomingTab?.classList.add('active');
  });
});

activeTab?.querySelector('a')?.setAttribute('href', 'javascript:void(0)');
activeTab?.addEventListener("click", (event)=> {
  backStep();
});


const goBackBtn = document.querySelector('[js-summary-step] [js-go-back]');
goBackBtn?.addEventListener("click", (event)=> {
  backStep();
});

const backStep = ()=> {
  window.scrollTo(500, 0);
    const addBtn = document.querySelector('[js-add-btn]');
    const summaryStep = document.querySelector('[js-summary-step]');
    const productsStep = document.querySelector('[js-products-step]');
    const bottomBar = document.querySelector('[js-bottom-bar]');

    nextBtns.forEach((nextBtn)=> {
      nextBtn.classList.remove('hidden');
     });
    addBtn?.classList.add('hidden');
    summaryStep?.classList.add('hidden');
    productsStep?.classList.remove('hidden');
    bottomBar?.classList.remove('hidden');
    activeTab?.classList.remove('completed');
    activeTab?.classList.add('active');
   upcomingTab?.classList.remove('active');
  
}

const PRE_ADDED_STORAGE_KEY = 'dd-pre-added';
const hasPreAddedFlagInStorage = () => {
  try {
    return window.localStorage?.getItem(PRE_ADDED_STORAGE_KEY) === 'true';
  } catch (error) {
    return false;
  }
};
const autoSelectPreAddedBundle = () => {
  const params = new URLSearchParams(window.location.search);
  const hasQueryFlag = params.get('pre-added') === 'true';
  const hasStorageFlag = hasPreAddedFlagInStorage();
  if (!hasQueryFlag && !hasStorageFlag) return;

  const cleanup = () => {
    if (hasQueryFlag) {
      const url = new URL(window.location.href);
      url.searchParams.delete('pre-added');
      window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
    }
  };

  let attempts = 0;
  const tryClick = () => {
    const targetBtn = document.querySelector('[js-main-section] [js-add]');
    if (targetBtn) {
      targetBtn.click();
      cleanup();
      return;
    }

    attempts += 1;
    if (attempts < 20) {
      setTimeout(tryClick, 100);
    }
  };

  tryClick();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', autoSelectPreAddedBundle);
} else {
  autoSelectPreAddedBundle();
}
